export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const GET_PROJECTS = 'GET_PROJECTS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const GET_SUCCESS = 'GET_SUCCESS';
export const GET_ERROR = 'GET_ERROR';
export const GET_REQUEST = 'GET_REQUEST';
export const SET_LOADING = 'SET_LOADING';
